import React, { useState } from 'react';
import { Button, Input, Form as AntForm, Alert, DatePicker } from 'antd';
import { Formik } from 'formik';
import openErrorNotification from '../../Utils/openErrorNotification';
import style from './Forms.module.css';
import { useDispatch } from 'react-redux';
import api from '../../Api/api';
import {
  REQUEST_GET_ALL_PROJECTS_FOR_ADMIN,
  REQUEST_GET_PROJECT_DATA,
} from '../../Redux/constants/constants';

const NewProject = () => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState('');

  return (
    <Formik
      initialValues={{
        number: '',
        name: '',
        status: 'active',
        startDate: undefined,
        endDate: undefined,
      }}
      validateOnChange={false}
      validate={(values) => {
        const errors = {};
        if (values.number === '') {
          errors.number = 'wymagane';
        }
        if (values.name === '') {
          errors.name = 'wymagane';
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        api
          .postProjectData(values)
          .then((res) => {
            setSubmitting(false);
            setStatus('saved');
            dispatch({ type: REQUEST_GET_PROJECT_DATA, payload: res.data.id });
            dispatch({ type: REQUEST_GET_ALL_PROJECTS_FOR_ADMIN });
          })
          .catch((e) => {
            setSubmitting(false);
            setStatus('error');
            openErrorNotification(e);
          });
      }}
    >
      {({ isSubmitting, values, errors, handleSubmit, setFieldValue }) => (
        <AntForm
          className={style.wrapper}
          labelCol={{ span: 8 }}
          layout="horizontal"
          wrapperCol={{ span: 16 }}
        >
          <AntForm.Item
            required={true}
            help={errors.number}
            label="Numer projektu"
            validateStatus={errors.number && 'error'}
          >
            <Input
              placeholder={values.number}
              onChange={(e) => {
                return setFieldValue('number', e.target.value);
              }}
            />
          </AntForm.Item>
          <AntForm.Item
            required={true}
            help={errors.name}
            label="Nazwa projektu"
            validateStatus={errors.name && 'error'}
          >
            <Input
              placeholder={values.name}
              onChange={(e) => {
                return setFieldValue('name', e.target.value);
              }}
            />
          </AntForm.Item>

          <AntForm.Item
            help={errors.startDate}
            label="Data rozpoczęcia"
            validateStatus={errors.startDate && 'error'}
          >
            <DatePicker
              style={{ width: '100%' }}
              placeholder={values.startDate}
              onChange={(date) => {
                console.log({ date });
                return setFieldValue(
                  'startDate',
                  date ? date.toISOString(true).slice(0, 10) : undefined
                );
              }}
            />
          </AntForm.Item>
          <AntForm.Item
            help={errors.endDate}
            label="Data zakończenia"
            validateStatus={errors.endDate && 'error'}
          >
            <DatePicker
              style={{ width: '100%' }}
              placeholder={values.endDate}
              onChange={(date) => {
                return setFieldValue(
                  'endDate',
                  date ? date.toISOString(true).slice(0, 10) : undefined
                );
              }}
            />
          </AntForm.Item>

          <Button type="submit" disabled={isSubmitting} onClick={handleSubmit}>
            Zapisz
          </Button>
          {status === 'saved' && (
            <Alert message="Projekt utworzony" type="success" showIcon />
          )}
          {status === 'error' && (
            <Alert message="Błąd zapisu" type="error" showIcon />
          )}
        </AntForm>
      )}
    </Formik>
  );
};

export default NewProject;
